module.exports = __webpack_public_path__ + "media/images/logos/glassdoor-21d800182b26ea13d7eb06c9a51fdf90.svg";